'use client';

import { useLocale, useTranslations } from "next-intl";
import { useActionState } from "react";
import { loginAction } from "@/lib/auth/login";
import { Link, redirect } from "@/i18n/navigation";

export default function LoginForm() {
  const t = useTranslations("auth");
  const locale = useLocale();
  const [state, action, pending] = useActionState(loginAction, undefined);

  if (!t) return <div>Loading...</div>
  if (state?.success) redirect({ locale, href: "/dashboard" })

  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-center p-4 bg-primary">
      <form action={action} className="w-full max-w-sm animate-scale-in">
        {/* Brand header */}
        <div className="flex flex-col items-center gap-3 mb-8">
          <svg
            className="w-10 h-10 text-accent-1"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <circle cx="12" cy="12" r="6" />
            <circle cx="12" cy="12" r="2" />
          </svg>
          <h1 className="text-2xl font-black tracking-tight">
            Tot<span className="text-accent-1">Scorer</span>
          </h1>
          <p className="text-sm text-gray-400">{t("login")}</p>
        </div>

        <div className="centered-form-container">
          {/* License */}
          <div className="form-field">
            <label htmlFor="license" className="form-label">{t("license")}</label>
            <input
              type="text"
              id="license"
              name="license"
              className="forminput"
              required
              autoComplete="username"
            />
          </div>

          {/* Password */}
          <div className="form-field">
            <label htmlFor="password" className="form-label">{t("password")}</label>
            <input
              type="password"
              id="password"
              name="password"
              className="forminput"
              required
              autoComplete="current-password"
            />
          </div>

          {/* Error */}
          {state?.error && (
            <p className="text-error text-sm font-medium">{state.error}</p>
          )}

          {/* Register link */}
          <p className="text-sm text-gray-400">
            {t("noAccount")}&nbsp;
            <Link href="/register" className="link font-medium">{t("register")}</Link>
          </p>

          {/* Submit */}
          <button type="submit" className="submit-button" disabled={pending}>
            {pending ? (
              <span className="flex items-center justify-center gap-2">
                <span className="w-4 h-4 rounded-full border-2 border-white/30 border-t-white animate-spin" />
                {t("wait")}
              </span>
            ) : t("login")}
          </button>
        </div>
      </form>
    </div>
  )
}
